import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ImportsModule } from "../../../shared/imports.module";
import { Sociedad, Division, Beneficiario, Usuario } from '../../../shared/models';
import { CommonModule, CurrencyPipe, DatePipe, SlicePipe } from '@angular/common';
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { saveAs } from 'file-saver';
import { finalize, Subject, takeUntil } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { BeneficiariosService } from '../../services/beneficiarios.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NzUploadFile, NzUploadModule } from 'ng-zorro-antd/upload';
import { HomeService } from '../../services/home.service';
import { PerfilStore } from '../../store/perfil.store';

@Component({
  selector: 'app-subir-archivos-beneficiario',
  standalone: true,
  imports: [ImportsModule, CommonModule, DatePipe, NzSpinModule, NzDatePickerModule, ReactiveFormsModule, NzUploadModule],
  templateUrl: './subir-archivos-beneficiario.component.html',
  styleUrl: './subir-archivos-beneficiario.component.scss'
})
export class SubirArchivosBeneficiarioComponent implements OnInit {
  
  beneficiarioForm!: FormGroup;
  $onDestroy: Subject<void> = new Subject<void>();
  beneficiarios: Beneficiario[] = [];
  enviando = false;
  user: Usuario | null = null;
  fileList: NzUploadFile[] = [];
  beneficiarioDisabled = false;
  
  constructor(
    private fb: FormBuilder,
    private beneficiariosService: BeneficiariosService,
    private colaboradoresService: HomeService,
    private message: NzMessageService,
    private cdr: ChangeDetectorRef,
    private sessionStore: PerfilStore,
    private drawerRef: NzDrawerRef,
    private homeService : HomeService
  ) {

  }
  
  ngOnInit(): void {
    this.getUser();
  }

  getUser() {
    this.sessionStore
      .getPerfil()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe((user:Usuario | null) => {
        this.user = user;
        this.initForm();
      });
  }

  ngOnDestroy() {
    this.$onDestroy.next();
    this.$onDestroy.complete();
  }
  
  private initForm(): void {
    this.beneficiarioForm = this.fb.group({
      fechaInicio: [null, [Validators.required]],
      numeroFetos: [1, [Validators.required, Validators.min(1), Validators.max(10)]],
      colaboradorEsGestante: [(this.user?.genero == "Femenino"), [Validators.required]],
      beneficiarioId: [null]
    });
    if(!this.beneficiarioForm.get('colaboradorEsGestante')?.value) {
        this.beneficiarioForm.get('beneficiarioId')?.setValidators([Validators.required]);
      }
      this.cargarBeneficiarios();
  }
  
  private cargarBeneficiarios(): void {
    this.beneficiarios = [];

    this.colaboradoresService.obtenerDetalleBeneficiarios(this.user?.colaboradorId!).subscribe({
      next: (res) => {
        this.beneficiarios = res.details as Beneficiario[] || [];
        this.cdr.detectChanges();
        if((this.user?.genero == "Masculino")) this.selectBeneficiario();
      },
      error: (error) => {
        this.message.error('Error al cargar beneficiarios');
      }
    });
  }

  selectBeneficiario() {
    this.beneficiarioDisabled = true;
    this.beneficiarioForm.get('beneficiarioId')?.setValidators([Validators.required]);
    if (this.beneficiarios.length > 0) {
      const selectedBeneficiario = this.beneficiarios.find(b => b.parentescoId == 2);
      if( selectedBeneficiario ){
        this.beneficiarioForm.get('beneficiarioId')?.setValue(selectedBeneficiario.id);
      }
    }
    this.beneficiarioForm.get('beneficiarioId')?.updateValueAndValidity();
  }
  
  beforeUpload = (file: NzUploadFile): boolean => {
    this.fileList = this.fileList.concat(file);
    return false;
  };
  
  handleChange(info: any): void {
    let fileList = [...info.fileList];
    
    fileList = fileList.slice(-5);
    
    this.fileList = fileList;
  }
  
  submit(): void {
    if (this.fileList.length === 0) {
      this.message.warning('Por favor seleccione al menos un archivo');
      return;
    }
    if (this.beneficiarioForm.valid) {
      this.enviando = true;
      const formValues = this.beneficiarioForm.getRawValue();
      this.beneficiariosService.subirDatos(
        formValues.fechaInicio,
        formValues.numeroFetos,
        formValues.colaboradorEsGestante,
        formValues.beneficiarioId,
        this.fileList,
        this.user?.colaboradorId!
      ).pipe(
        finalize(() => {
          this.enviando = false;
          this.cdr.detectChanges();
        }
        )
      )
      .subscribe({
        next: (response) => {
          this.message.success('Datos enviados correctamente');
          this.resetForm();
          this.drawerRef.close();
        },
        error: (error) => {
          this.message.error('Error al enviar los datos: ' +  'Favor de Validar con el Administrador si ya existe un proceso de solicitud');
        }
      });
    } else {
      this.message.warning('Por favor complete todos los campos requeridos');
      this.markFormGroupTouched();
    }
  }
  
  cancelar(): void {
    this.resetForm();
    this.message.info('Formulario cancelado');
  }
  
  private resetForm(): void {
    this.beneficiarioForm.reset();
    this.fileList = [];
    this.beneficiarioForm.patchValue({
      numeroFetos: 1,
      colaboradorEsGestante: false
    });
  }
  
  private markFormGroupTouched(): void {
    Object.keys(this.beneficiarioForm.controls).forEach(key => {
      const control = this.beneficiarioForm.get(key);
      control?.markAsTouched();
    });
  }
  disabledDate = (current: Date): boolean => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    yesterday.setHours(23, 59, 59, 999);
    return current && current.getTime() > yesterday.getTime();
  };
}
